import { t } from '@framework/i18n/intl/i18next.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import {
  type ColumnGroupType,
  type ColumnsType,
  type ColumnType,
} from 'antd/es/table';
import { type IPublicAreaItem } from './getTableTreeDataFromCartelle.tsx';
import { PublicFileTypeTag } from './PublicFileTypeTag.tsx';
import { TableFolderName } from './TableFolderName.tsx';

export const foldersColumnsBase = {
  nome: {
    title: t('folder.nome', 'Nome'),
    dataIndex: 'nome',
    key: 'nome',
    width: '30%',
    ellipsis: true,
    // sorter: true,
    // sortDataIndex: 'nome',
    // onCell: (record, index) => ({
    //   colSpan: record.isFolder ? 2 : 1,
    // }),
    render: (_, record) => <TableFolderName record={record} />,
    // ...createColumnFilter(FilterInputType.Text),
  },
  numeroProtocollo: {
    title: t('folder.protocollo', 'Protocollo'),
    dataIndex: 'numeroProtocollo',
    key: 'numeroProtocollo',
    // sorter: true,
    // sortDataIndex: 'numeroProtocollo',
    render: (_, record) =>
      record.type === 'file' ? record.numeroProtocollo : null,
    // ...createColumnFilter(FilterInputType.Text),
  },
  descrizione: {
    title: t('folder.descrizione', 'Descrizione'),
    dataIndex: 'descrizione',
    key: 'descrizione',
    // sorter: true,
    // sortDataIndex: 'descrizione',
    render: (_, record) => (record.type === 'file' ? record.descrizione : null),
    // ...createColumnFilter(FilterInputType.Text),
  },
  tipo: {
    title: t('folder.tipo', 'Tipo'),
    dataIndex: 'tipo',
    key: 'tipo',
    // sorter: true,
    // sortDataIndex: 'tipo',
    render: (_, record) =>
      record.type === 'file' ? <PublicFileTypeTag record={record} /> : null,
  },
  dataProtocollo: {
    title: t('folder.data', 'Data'),
    dataIndex: 'dataProtocollo',
    key: 'dataProtocollo',
    width: 100,
    // sorter: true,
    // sortDataIndex: 'dataProtocollo',
    render: (_, record) =>
      record.type === 'file' ? (
        <ISODate date={record.dataProtocollo ?? record.dataDocumento} />
      ) : null,
  },
  // Non utilizzata
  dataDocumento: {
    title: t('folder.data-documento', 'Data Documento'),
    dataIndex: 'dataDocumento',
    key: 'dataDocumento',
    width: 100,
    // sorter: true,
    // sortDataIndex: 'dataDocumento',
    render: (_, record) =>
      record.type === 'file' ? <ISODate date={record.dataDocumento} /> : null,
  },
} satisfies Record<
  string,
  ColumnGroupType<IPublicAreaItem> | ColumnType<IPublicAreaItem>
>;

export const foldersColumns: ColumnsType<IPublicAreaItem> = [
  foldersColumnsBase.nome,
  foldersColumnsBase.numeroProtocollo,
  foldersColumnsBase.dataProtocollo,
  foldersColumnsBase.tipo,
  foldersColumnsBase.descrizione,
];

export const foldersColumnsMobile: ColumnsType<IPublicAreaItem> = [
  foldersColumnsBase.nome,
  foldersColumnsBase.numeroProtocollo,
  foldersColumnsBase.descrizione,
];
